(function () {
  'use strict';

  var ATC = {
    cfg: {
      button: 'form.js-product-form-quickshop .js-ajax-submit.add-item',
      productJson: '.product-json',
      formVariant: '#formVariantId',
      label: 'Add to Cart',
      preorder: 'Pre Order',
      soldOut: 'SOLD OUT'
    },
    el: null,
    product: null,

    init: function () {
      this.el = document.querySelector(this.cfg.button);
      if (!this.el) return;

      this.product = this.json(this.cfg.productJson);
      if (!this.product || !this.product.variants) return;

      var self = this;

      // NOTE: no initial render on page load — button text update sirf variant change pe hoga
      this.retry(function () { return window.Events && typeof window.Events.on === 'function'; }, function () {
        window.Events.on('variantinputchange', function (v) { self.render(v); });
      });
    },

    json: function (sel) {
      var el = document.querySelector(sel);
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    },

    retry: function (cond, cb, n) {
      n = n || 0;
      if (cond() || n >= 25) { cb(); return; }
      var self = this;
      setTimeout(function () { self.retry(cond, cb, n + 1); }, 100);
    },

    isPreOrder: function (v) {
      return !!v && v.available && v.inventory_management != null && v.inventory_quantity <= 0;
    },

    render: function (v) {
      if (!this.el || !v) return;

      this.el.disabled = !v.available;

      if (!v.available) {
        this.el.textContent = this.cfg.soldOut;
      } else if (this.isPreOrder(v)) {
        this.el.textContent = this.cfg.preorder;
      } else {
        this.el.textContent = this.cfg.label;
      }
    }
  };

  window.AtcButtonRedesign = ATC;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ATC.init(); });
  } else { ATC.init(); }
})();